import axiosClient from "./axiosClient";

export const getSignatures = async ({ includeInactive = false } = {}) => {
  const response = await axiosClient.get("/signatures/", {
    params: includeInactive ? { include_inactive: true } : {},
  });
  return response.data?.results || [];
};

export const createSignature = async ({ name, title, signatureImage, isActive = true }) => {
  const formData = new FormData();
  formData.append("name", name);
  formData.append("title", title);
  formData.append("signature_image", signatureImage);
  formData.append("is_active", String(isActive));
  const response = await axiosClient.post("/signatures/", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return response.data;
};

export const updateSignature = async (signatureId, payload) => {
  const hasImage = payload.signatureImage instanceof File;
  const requestBody = hasImage ? new FormData() : {};

  if (hasImage) {
    requestBody.append("signature_image", payload.signatureImage);
    if (payload.name !== undefined) requestBody.append("name", payload.name);
    if (payload.title !== undefined) requestBody.append("title", payload.title);
    if (payload.isActive !== undefined) {
      requestBody.append("is_active", String(payload.isActive));
    }
  } else {
    if (payload.name !== undefined) requestBody.name = payload.name;
    if (payload.title !== undefined) requestBody.title = payload.title;
    if (payload.isActive !== undefined) requestBody.is_active = payload.isActive;
  }

  const response = await axiosClient.patch(`/signatures/${signatureId}/`, requestBody, hasImage
    ? { headers: { "Content-Type": "multipart/form-data" } }
    : undefined);
  return response.data;
};
